import React from 'react';
import { Icon } from '@chakra-ui/react';
import {
  MdHome,
  MdPerson,
  MdLock,
  MdOutlineShoppingCart,
  MdBookOnline,
  MdTempleHindu,
  MdEventNote,
} from 'react-icons/md';

// Admin Imports
import Dashboard from 'views/admin/default';
import PoojaManagement from 'views/admin/Pooja';
import PoojaBookingManagement from 'views/admin/PoojaBooking';
import ProductBookingManagement from 'views/admin/Booking';
import Product from 'views/admin/Product';
import User from 'views/admin/User';

// Auth Imports
import SignInCentered from 'views/auth/signIn';
import SignUpCentered from 'views/auth/SignUp';
import ForgotCentered from 'views/auth/ForgotPassword';

const routes = [
  // ── Admin Routes ─────────────────────────────────────────────
  {
    name: 'Dashboard',
    layout: '/admin',
    path: '/default',
    icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
    component: <Dashboard />,
  },
  {
    name: 'Pooja Management',
    layout: '/admin',
    path: '/poojas',
    icon: <Icon as={MdTempleHindu} width='20px' height='20px' color='inherit' />,
    component: <PoojaManagement />,
  },
  {
    name: 'Pooja Bookings',
    layout: '/admin',
    path: '/pooja-bookings',
    icon: <Icon as={MdEventNote} width='20px' height='20px' color='inherit' />,
    component: <PoojaBookingManagement />,
  },
  {
    name: 'Products',
    layout: '/admin',
    icon: <Icon as={MdOutlineShoppingCart} width='20px' height='20px' color='inherit' />,
    path: '/products',
    component: <Product />,
  },
  {
    name: 'Order Bookings',
    layout: '/admin',
    icon: <Icon as={MdBookOnline} width='20px' height='20px' color='inherit' />,
    path: '/booking',
    component: <ProductBookingManagement />,
  },
  {
    name: 'Customers',
    layout: '/admin',
    icon: <Icon as={MdPerson} width='20px' height='20px' color='inherit' />,
    path: '/customer',
    component: <User />,
  },
  // ── Auth Routes (hidden from sidebar) ───────────────────────
  {
    name: 'Sign In',
    layout: '/auth',
    path: '/sign-in',
    icon: <Icon as={MdLock} width='20px' height='20px' color='inherit' />,
    component: <SignInCentered />,
  },
  {
    name: 'Sign Up',
    layout: '/auth',
    path: '/sign-up',
    icon: <Icon as={MdLock} width='20px' height='20px' color='inherit' />,
    component: <SignUpCentered />,
  },
  {
    name: 'Forgot Password',
    layout: '/auth',
    path: '/forgot-password',
    icon: <Icon as={MdLock} width='20px' height='20px' color='inherit' />,
    component: <ForgotCentered />,
  },
];

export default routes;
